import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';

export const fetchWorkingTimeStatistics = createAsyncThunk(
    'workingTimeStatistics/fetch',
    async ({ page, query }, { getState, rejectWithValue }) => {
        try {
            const perPage = 100; //changed this to get all items, not only 10 per page

            const state = getState().workingTimeStatistics.statistics;

            const { maxPageNumber, statistics, columns, holidays } = await API.workingTime.get(page, perPage, query);

            const result = {
                maxPageNumber,
                holidays,
                statistics: page ? [...state, ...statistics] : statistics,
                columns,
            };

            return result;
        } catch (err) {
            notification.error({ message: 'ERROR', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);
